module.exports = __webpack_public_path__ + "img/handshake.8e6e89bd.png";